import config from '../config';

interface SetDefaultRoutingProfileRequest {
  userIds: string[];
  routingProfileId: string;
}

export const setDefaultRoutingProfile = async (request: SetDefaultRoutingProfileRequest): Promise<void> => {
  const apiUrl = config.catoApiUrl;

  if (!apiUrl) {
    throw new Error('Agent Allocation API Url is not configured');
  }

  const url = `${apiUrl}/default-routing-profiles`;

  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request)
  });

  if (!response.ok) {
    throw new Error(`Failed to set default routing profiles: ${response.status} ${response.statusText}`);
  }
};
